import { HOLIDAYS_URL } from "api/routes";
import { instance } from "hooks/useRequest/helper";
import { IGetHolidayResponse } from "rules/interface/api/holiday/holiday.interface";
import { IServerGetResponse } from "rules/interface/api/response";


export const checkIsHoliday = async (data: { date: string }): Promise<IServerGetResponse<IGetHolidayResponse>> => {
    return await instance
        .post(HOLIDAYS_URL, { ...data })
        .then(res => res.data);
};